export const NAVIGATION_RESTRICTIONS = {
  0: 48,
  1: 48,
  2: 60,
  3: 60,
  4: 60,
  5: 60,
};
